import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; // Ensure this is imported
import useAuth from '../../dashboard/useAuth';
import { FaBoxes, FaTools } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import axios from 'axios';

const Ajouter_produit = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');

    const [description, setDescription] = useState(''); // State for ReactQuill content

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter Produit"; // Définit le titre de la page
        }
    }, [user_id]);

    const navigate = useNavigate();  // Hook pour la redirection

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        // Add the description manually to the form data
        formData.append('description', description);

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-produit/${user_id}/`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                // Vous pouvez afficher un message d'erreur ici
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                // Redirection après le succès
                navigate(`/Liste-produit`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handleCancel = () => {
        window.location.reload(); // Redirection après 7 secondes
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // En-têtes
            ['bold', 'italic', 'underline'], // Styles de texte
            ['link', 'image'], // Ajouter des liens et des images
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
            ['clean'], // Bouton pour effacer le format
            [{ 'align': [] }], // Alignement du texte
        ],
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Produits")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaBoxes size={25} className='mr-2' /> Nouveau Produit</h2>
                            <small>Administration des produits.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-produit`}> Produits</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Ajouter-produit`}> Nouveau Produit</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid"> {/* Utiliser container-fluid pour une meilleure adaptabilité */}
                        <div className="row justify-content-center"> {/* Centrer la colonne sur la page */}
                            <div className="col-12 col-lg-8 mt-5 mb-3"> {/* Ajuster la largeur selon la taille de l'écran */}
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                                <div className="form-group">
                                                    <label>Nom*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le nom"
                                                        required
                                                        name="nom"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Description*</label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={description}
                                                        onChange={setDescription}
                                                        modules={modules}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Prix*</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Entrez le Prix"
                                                        required
                                                        name="prix"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Période*</label>
                                                    <select className="form-control" name="periode" required>
                                                        <option value="">Sélectionner une période</option>
                                                        {[...Array(12)].map((_, index) => {
                                                            const mois = index + 1;
                                                            const heures = mois * 730;
                                                            return (
                                                                <option key={mois} value={heures}>
                                                                    {mois} {mois === 1 ? "mois" : "mois"} ({heures} heures)
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Photo*</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        required
                                                        name="photo"
                                                        accept="image/*"
                                                    />
                                                </div>
                                                <div className="text-center mt-4">
                                                    <a href='/Liste-produit' className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default Ajouter_produit;
